import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { succsesDataChangeAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const CurrentFeature = () => {
    const navigate = useNavigate();

    const permissions = useSelector((state) => state.status.permissions);

    const { id } = useParams();

    const [title, setTitle] = useState("");
    const [titleWebsite, setTitleWebsite] = useState("");
    const [isFilter, setIsFilter] = useState(0);
    const [activeCategories, setActiveCategories] = useState([]);
    const [featureItems, setFeatureItems] = useState([]);
    const [items, setItems] = useState("");

    const { data: feature, refetch: refetchFeature } = useGetPageQuery("features/" + id);
    const { data: categorySelect } = useGetPageQuery("categories/select");
    const [sendForm, { isLoading, isError }] = useSendFormMutation();

    useEffect(() => {
        if (feature) {
            setTitle(feature.title);
            setTitleWebsite(feature.title_website);
            setIsFilter(feature.is_filter);
            setActiveCategories(feature.categories.map((category) => category.id));
            setItems(feature.items.map((item) => item.title).join("\n"));
        }
    }, feature);

    useEffect(() => {
        if (items) {
            setFeatureItems(
                items
                    .split("\n")
                    .map((item) => {
                        if (item.length) {
                            return { title: item.trim() };
                        }
                    })
                    .filter((item) => item !== undefined)
            );
        }
    }, [items]);

    const sendFormHandler = async () => {
        const formData = {
            title: title,
            title_website: titleWebsite,
            is_filter: isFilter,
            category_ids: activeCategories,
            items: featureItems,
        };

        await sendForm({ body: formData, url: "features/" + id, method: "PUT" }).unwrap();
        await refetchFeature();

        if (!isError) {
            succsesDataChangeAlert();
            navigate("/features/0");
        }
    };

    const selectedOptionsHandler = (options) => {
        const value = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(options[i].value);
            }
        }
        setActiveCategories(value);
    };

    return (
        <>
            {feature && categorySelect && (
                <div className="content">
                    <div className="col-12">
                        <div id="page-header">
                            <h1>{feature.title}</h1>
                        </div>
                        <div className="form user_form">
                            <input name="id" type="hidden" />
                            <div className="row">
                                <div className="col-12 col-sm-6 col-md-6">
                                    <div className="card card-default">
                                        <div className="card-header">
                                            Інформація
                                            <div className="custom-control custom-checkbox float-end">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input mx-1"
                                                    checked={isFilter}
                                                    onChange={(e) => setIsFilter(e.target.checked)}
                                                />
                                                <label className="form-check-label">Відображати в фільтрі</label>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label">Назва</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={title}
                                                    onChange={(e) => setTitle(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Назва на сайті</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={titleWebsite}
                                                    onChange={(e) => setTitleWebsite(e.target.value)}
                                                />
                                            </div>
                                            <div className="input-group">
                                                <span className="input-group-text">Варіанти</span>
                                                <textarea
                                                    className="form-control"
                                                    aria-label="With textarea"
                                                    value={items}
                                                    onChange={(e) => setItems(e.target.value)}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="card card-default">
                                        <div className="card-header">Категорії характеристики</div>
                                        <div className="card-body">
                                            <div className="form-group last">
                                                <label className="form-label">
                                                    Категорії{" "}
                                                    <span style={{ fontSize: "12px", fontWeight: "normal" }}>
                                                        (характеристики будуть виводитись тільки для категорій які
                                                        відмічені)
                                                    </span>
                                                </label>
                                                <select
                                                    className="form-select"
                                                    style={{ height: "160px" }}
                                                    multiple
                                                    aria-label="multiple select example"
                                                    onChange={(e) => selectedOptionsHandler(e.target.options)}
                                                >
                                                    {categorySelect.map((selectCategory) => {
                                                        return (
                                                            <option
                                                                value={selectCategory.id}
                                                                key={selectCategory.id}
                                                                selected={activeCategories.includes(selectCategory.id)}
                                                            >
                                                                {"\u00A0\u00A0\u00A0\u00A0\u00A0".repeat(
                                                                    selectCategory.level
                                                                ) + selectCategory.title}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 clearfix">
                                    {permissions.includes("feature_edit") || permissions.includes("all") ? (
                                        <div className="saves_block">
                                            <button className="btn btn-labeled btn-primary" onClick={sendFormHandler}>
                                                {isLoading ? "Завантаження" : "Зберегти"}
                                            </button>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CurrentFeature;
